module.exports = __webpack_public_path__ + "img/camping.2e7957ac.svg";